import axios from "axios";
import qs from "qs";
import { baseUrl } from "../config/EnVariables";
const token = localStorage.getItem("access_token");
const user = JSON.parse(localStorage.getItem("user"));
const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};
const Account = {
  downloadFile: async (file) =>
    await axios.get(
      `${baseUrl}/download?fileName=${file}&entity=GENERAL%20JOURNAL`,
      {
        headers: headers,
      }
    ),
  getAllAccounts: async () =>
    await axios.get(
      `${baseUrl}/acc-accounts/?branchId=${user.branchId}&size=100`,
      {
        headers: headers,
      }
    ),
  getAccountsByType: async (type) =>
    await axios.get(
      `${baseUrl}/acc-accounts/?branchId=${user.branchId}&accountTypeName=${type}`,
      {
        headers: headers,
      }
    ),

  filterAccount: async (account) =>
    await axios.get(
      `${baseUrl}/acc-accounts/?branchId=${user.branchId}&name=${account}`,
      {
        headers: headers,
      }
    ),
  getExpandingAccounts: async (branchId) =>
    await axios.get(
      `${baseUrl}/acc-accounts/chart-of-accounts/?branchId=${
        user.branchId || branchId
      }&size=100`,
      {
        headers: headers,
      }
    ),
  addJournelEntry: (data) =>
    axios.post(`${baseUrl}/general-journals`, data, { headers: headers }),

  getAccountTypes: () =>
    axios.get(`${baseUrl}/account-types`, {
      headers: headers,
    }),

  //Currencies
  getActivatedCurrencies: () =>
    axios.get(`${baseUrl}/currencies/activated`, {
      headers: headers,
    }),
  getCurrencyRate: async () =>
    await axios.get(
      `${baseUrl}/currency-rates/latest-branch-rates/?branchId=${user.branchId}`,
      {
        headers: headers,
      }
    ),
  updateCurrencyRate: async (data) =>
    await axios.post(
      `${baseUrl}/currency-rates/?branchId=${user.branchId}`,
      data,
      {
        headers: headers,
      }
    ),
  createAccount: async (data) => {
    console.log("Data in createAccount", data);
    const response = await axios.post(`${baseUrl}/acc-accounts`, data, {
      headers: headers,
    });
    return response;
  },
  //Reports
  getAccountQuickReport: (data) =>
    axios.get(
      `${baseUrl}/transaction-lines/account-transaction-report?accountId=${data.accountId}&startDate=${data.startDate}&endDate=${data.endDate}`,
      {
        headers: headers,
      }
    ),
  getGeneralLedger: (data) =>
    axios.get(
      `${baseUrl}/transaction-lines/general-ledger?branchId=${user.branchId}`,
      {
        headers: headers,
      }
    ),
  getJournals: (data) =>
    axios.get(
      `${baseUrl}/general-journals/?branchId=${user.branchId}&page=0&size=35`,
      {
        headers: headers,
      }
    ),
  getTransactionLines: (journelId) =>
    axios.get(
      `${baseUrl}/transaction-lines/general-journal-lines?generalJournalId=${journelId}`,
      {
        headers: headers,
      }
    ),
  getTrialBalance: (data) =>
    axios.get(
      `${baseUrl}/transaction-lines/trial-balance/?branchId=${user.branchId}`,
      {
        headers: headers,
      }
    ),
  getIncomeStatement: (data) =>
    axios.get(
      `${baseUrl}/transaction-lines/income-statement/?branchId=${user.branchId}&startDate=${data.startDate}&endDate=${data.endDate}`,
      {
        headers: headers,
      }
    ),

  getBalanceSheet: (data) =>
    axios.get(
      `${baseUrl}/transaction-lines/balance-sheet/?branchId=${user.branchId}`,
      {
        headers: headers,
      }
    ),

  update: (data, ID) =>
    axios.post(`buildings/updateBuilding`, { buildingid: ID, ...data }),

  getByMember: (ID, pagination, date) =>
    axios.get(
      `/transfer/member/${ID}?${qs.stringify(pagination)}&${qs.stringify(date)}`
    ),

  remove: (data) => axios.post("/buildings/removeBuilding", data),
};

export default Account;
